import { useState, useEffect } from "react";

// Use to create a smooth timer that ticks every second.
// If an endTime is provided, then the timer will stop updating.
export const useElapsedTime = (
  startTime: number,
  endTime?: number,
): { millis: number } => {
  // Just used to force a re-render every second
  const [_tick, setTick] = useState(0);

  useEffect(() => {
    // If we have an endTime, no need to update
    if (endTime) return;

    const interval = setInterval(() => setTick((t) => t + 1), 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  return {
    millis: (endTime ?? Date.now()) - startTime,
  };
};
